import { createMemo, createSignal, Show } from "solid-js";
import { register_str } from "./api_common";
import { Input } from "./common";

export default function Register() {
  let [ready, setReady] = createSignal(false);
  let zxcvbn;
  import("/ext/zxcvbn.js").then((m) => {
    zxcvbn = m.zxcvbn;
    setReady(true);
  });

  let [email, setEmail] = createSignal("");
  let [password, setPassword] = createSignal("");
  let [isSent, setIsSent] = createSignal(false);

  let result = createMemo(() => {
    if (!ready()) return;
    const p = password();
    if (p === null || p.length === 0) return;
    return zxcvbn(p);
  });

  let disabled = () => {
    if (password().length < 8) {
      return true;
    }
    const re = /\S+@\S+\.\S+/;
    return !re.test(email());
  };

  const do_signUp = () => {
    register_str("email:" + email(), password());
    setIsSent(true);
  };

  return <div>
    <div>
      <form method="dialog">
      <Input label="Email" type="email" autocomplete="email" value={email()} onchange={(e) => setEmail(e.target.value)} />
      <Input
        label="Password"
        type="password"
        autocomplete="new-password"
        oninput={(e) => setPassword(e.target.value)}
      />
      </form>
    </div>
    <Show when={result()}>
      <div>
      <dl>
        <dt>Time to crack password:</dt>
        <dd>{result().crack_times_display}</dd>
        <dt>Score:</dt>
        <dd>{result().score}</dd>
        <dt>Time to crack password:</dt>
        <dd>{result().crack_times_display.offline_slow_hashing_1e4_per_second}</dd>
      </dl>
      <Show when={result().feedback} keyed>
        {(feedback) => <><p>{feedback.warning}</p><p>{feedback.suggestions}</p></>}
      </Show>
      </div>
    </Show>
    <button type="submit" on:click={do_signUp} disabled={disabled()}>
      Sign up
    </button>
    <Show when={isSent()}>
      <p>An email has been sent to your inbox. Please check it and set a password with the given link.</p>
    </Show>
  </div>
}
